import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  font-size: 1.125rem;
  font-weight: 700;
  text-align: center;
`;
